// extracted by mini-css-extract-plugin
module.exports = {"error":"#ff4040","success":"#28cb93","primary-color":"#00bfb2","dark-grey-color":"#444","container":"registerProponent_container__wnO9J","icon":"registerProponent_icon__pd0iw"};